<div *ngIf="isAdmin">
  <spinner id="loading" *ngIf="loading" messageRelativePosition="bottom"> </spinner>

  <div *ngIf="!loading" class="flx-container">
    <div *ngIf="siteVisit" class="flx-item">
      <ambasssador-listing-card [siteVisit]="siteVisit"> </ambasssador-listing-card>
    </div>

    <div class="flx-break"></div>

    <div class="flx-item">
      <div>Choose Ambassador:</div>

      <div>
        <select class="form-control" [(ngModel)]="selectedAccount" [ngModelOptions]="{ standalone: true }">
          <!-- Safari Hack -- See https://stackoverflow.com/a/50418271/386619 -->
          <option disabled selected value="null">-- Choose Ambassador --</option>

          <option *ngFor="let item of externalAccounts" [ngValue]="item.userAccountId">{{ item.fullName }}</option>
        </select>
      </div>
    </div>

    <div class="flx-break"></div>

    <div class="flx-item">
      <button [disabled]="!scheduleEnabled" class="btn btn-primary btn-round hvr-push" (click)="onScheduleClick()">Schedule</button>
    </div>

    <div class="flx-break"></div>

    <div class="flx-item">
      <a class="btn btn-default btn-round hvr-push" [routerLink]="['/ambassador']">Return to Ambassador Page</a>
    </div>
  </div>
</div>

<div class="error-text" *ngIf="!isAdmin">You are not authorized to view this page.</div>
